import * as React from 'react';

import { ContextService } from 'src/core/services/context.service';
import { CardController } from 'src/app/shared/card.controller';
import { AgentContactPartView } from './agent-contact.view';

interface Props extends ComponentViewProps<ContactItem[]> {
	parentModel: AgentItem;
	mode: ControlMode;
	contextService: ContextService;
}

export class AgentContactPartController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			model, parentModel,
			contextService, mode, setBusy
		} = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				title="Addresses"
				className="card-borderless"
				icon="idcard"
				mode={mode}>
				<AgentContactPartView
					parentModel={parentModel}
					model={model}
					mode={mode}
					contextService={contextService}
					setBusy={setBusy}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/parts/agent-contact.controller.tsx